import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Product } from '../../../../../../shared/types/systemConfiguration/products';

export const useProductData = (product?: Product) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            code: '',
            description: '',
            active: true,
            applyEscalations: true,
            applyPqr: true,
            sfcCaptureUnit: '',
            sfcCaptureUnitNew: '',
        },
        onSubmit: console.log,
    });

    const sfcCaptureUnitName =
        typeof product?.sfcCaptureUnit === 'object' &&
        product?.sfcCaptureUnit?.name
            ? product.sfcCaptureUnit.name
            : '';

    const sfcCaptureUnitNewName =
        typeof product?.sfcCaptureUnitNew === 'object' &&
        product?.sfcCaptureUnitNew?.name
            ? product.sfcCaptureUnitNew.name
            : '';

    useEffect(() => {
        formik.setValues({
            name: product?.name || '',
            code: product?.code || '',
            description: product?.description || '',
            active: product?.active ?? false,
            applyEscalations: product?.applyEscalations ?? false,
            applyPqr: product?.applyPqr ?? false,
            sfcCaptureUnit: sfcCaptureUnitName,
            sfcCaptureUnitNew: sfcCaptureUnitNewName,
        });
    }, [product]);

    return {
        formik,
    };
};
